import * as React from 'react';
import ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import { FilterPageList } from './components/filterPageList';
import { Testimonials } from './components/testimonials';
import { Timeline } from './components/timeline';
import { AlterNav } from './fns/alterNav';
import { LogotypeSlideshow } from './components/logotypesSlideshow';
import { DemoPopUp } from './fns/demoPopup';
import { ServiceGroupItemCap } from './fns/serviceGroupCap';
emporiModule('bilvisionLoaded', {
    bilvision: {
        InitFilterPageList: function (element, items) {
            ReactDom.render(React.createElement(FilterPageList, { items: items }), element);
        },
        InitTestimonials: function (element, items) {
            ReactDom.render(React.createElement(Testimonials, { items: items }), element);
        },
        InitTimeline: function (element, stamps) {
            ReactDom.render(React.createElement(Timeline, { items: stamps }), element);
        },
        InitMainNav: function (element) {
            AlterNav(element);
        },
        InitLogotypeSlideshow: function (element, imgs) {
            ReactDom.render(React.createElement(LogotypeSlideshow, { imgs: imgs }), element);
        },
        InitDemoPopUp: function (element) {
            DemoPopUp(element);
        },
        InitServiceGroupItemCap: function (element) {
            ServiceGroupItemCap(element);
        }
    }
});
